import React from 'react';
import "./Wrapper.scss";
export type wrap = 'fixWrap' | 'fluidWrap' | "customWrap";
export interface Props {
  wrapClass: wrap;
  children?: any;
  wrapId?: any;
  wrapStyle?: React.CSSProperties;
}

export const Wrapper = ({
  wrapClass = "fixWrap",
  children,
  wrapId,
  wrapStyle
}: Props) => {
  return (
    <div className={wrapClass} id={wrapId} style={wrapStyle && wrapStyle}>
      {children}
    </div>
  )
}

export default Wrapper;